import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { SelectInput } from './rselect';
import dayjs from 'dayjs';
import styled from 'styled-components';
import { MoreInputFields } from './moreinputs'

let enable_submit

function DateDropdownField({frmid, stepId})
{
    const today = new Date(),
	  [step, setStep] = useState(null),
	  [day, setDay] = useState(null),
	  [month, setMonth] = useState(null),
	  [year, setYear] = useState(null),
	  [moreValidated, setMoreValidated] = useState(false),
	  [displayStr, setDisplayStr] = useState('')
    useEffect(() => {
	enable_submit(false)
	if ( frmid && stepId ) {
	    fetch(`/pub/form/${frmid}/${stepId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    setStep(json)
		    setDay(json.showCurrentDate ? {
			label: today.getDate(),
			value: today.getDate()
		    }: null)
		    setMonth(json.showCurrentDate ? {
			label: json.monthNames[today.getMonth()],
			value: json.monthNames[today.getMonth()]
		    }: null)
		    setYear(json.showCurrentDate ? {
			label: today.getFullYear(),
			value: today.getFullYear(),
		    }: null)
		    setMoreValidated(!('moreInputs' in json && json.moreInputs && json.moreInputs.length > 0))
		    enable_submit(!json.valueRequired)
		})
		.catch(r => {
		    console.error('error in operation: %O, %O [%O]', r.status, r.statusText, r)
		})
	}
    }, [frmid, stepId])
    useEffect(() => {
	if ( step && month && day && year ) {
	    const dateStr = `${day.value} ${month.value} ${year.value}`,
		  date = dayjs(dateStr, 'D MMMM YYYY')
	    if ( 'validRange' in step && step.validRange ) {
		const today = dayjs()
		if ( 'validStart' in step && step.validStart[0] !== null ) {
		    const start = step.validStart[2] === 'before' ?
			  today.subtract(step.validStart[0], step.validStart[1]) :
			  today.add(step.validStart[0], step.validStart[1])
		    console.log('converted validStart %O to date: %O, isAfter %O',
				step.validStart, start, date.isAfter(start))
		    if ( !date.isAfter(start) ) {
			enable_submit(false)
			return
		    }
		}
		if ( 'validEnd' in step && step.validEnd[0] !== null ) {
		    const end = step.validEnd[2] === 'before' ?
			  today.subtract(step.validEnd[0], step.validEnd[1]) :
			  today.add(step.validEnd[0], step.validEnd[1])
		    console.log('converted validEnd %O to date: %O, isBefore %O',
				step.validEnd, end, date.isBefore(end))
		    if ( !date.isBefore(end) ) {
			enable_submit(false)
			return
		    }
		}
	    }
	    const mon = step.monthNames.findIndex(x => x === month.value)
	    let corrected = false
	    if ( day.value != date.get('D') ) {
		setDay({value: date.get('D'), label: date.get('D')})
		corrected = true
	    }
	    if ( mon != date.get('M') ) {
		const mname = step.monthNames[date.get('M')]
		setMonth({value: mname, label: mname})
		corrected = true
	    }
	    if ( year.value != date.get('y') ) {
		setYear({value: date.get('y'), label: date.get('y')})
		corrected = true
	    }
	    if ( corrected ) {
		setDisplayStr(`${date.format(step.selectedDateFormat.value)} (corrected)`)
	    } else {
		setDisplayStr(date.format(step.selectedDateFormat.value))
	    }
	    enable_submit(moreValidated)
	}
    }, [month, day, year, moreValidated])
    window.gdd = (day, mno, year) => { // function for setting values from global javascript - used by selenium
	setDay({value: day, label: day})
	const mname = step.monthNames[mno]
	setMonth({value:mname, label: mname})
	setYear({value: year, label: year})
    }
    return (
	<>
	    {step ? (
		<>
		    {day && <input type="hidden" name={step.dataFields[0].id} value={day.value}/>}
		    {month && <input type="hidden" name={step.dataFields[1].id} value={month.value}/>}
		    {year && <input type="hidden" name={step.dataFields[2].id} value={year.value}/>}
		    {displayStr && <input type="hidden" name={step.dataFields[3].id} value={displayStr}/>}
		    <div class="row">
			<div class="col-12 col-xl-4">
			    <label class="form-label">{step.dayLabel}</label>
			    <SelectInput name={"id-" + step.dataFields[0].id}
					 options={[...Array(31).keys()].map(x => ({label: x+1, value: x+1}))}
					 value={day}
					 onChange={x => setDay(x)}/>
			</div>
			<div class="col-12 col-xl-4">
			    <label class="form-label">{step.monthLabel}</label>
			    <SelectInput name={"id-" + step.dataFields[1].id}
					 options={step.monthNames.map(name => ({value: name, label: name}))}
					 value={month}
					 onChange={m => setMonth(m)}/>
			</div>
			<div class="col-12 col-xl-4">
			    <label class="form-label">{step.yearLabel}</label>
			    <SelectInput name={"id-" + step.dataFields[2].id}
					 options={[...Array(step.numYears+1).keys()]
						  .map(x => x + step.yearStart)
						  .map(x => ({label:x, value:x}))}
					 value={year}
					 onChange={y => setYear(y)}/>
			</div>
		    </div>
		</>
	    ) : (
		<div class="spinner-border text-secondary" role="status">
		    <span class="visually-hidden">Loading...</span>
		</div>
	    )}
	    {displayStr && (
		<div class="form-text tertiary-text">
		    <span class="me-2">Selected date is:</span><span>{displayStr}</span>
		</div>
	    )}
	    {step && <MoreInputFields step={step} setValidated={setMoreValidated}/>}
	</>
    )
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  frmid = el.getAttribute('data-frmid')
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<DateDropdownField frmid={el.getAttribute('data-frmid')}
					     stepId={stepId}/>);
})();
